import Footer from '../components/footer';
import { NavbarComponent } from '../components/navbar';
import heroPhone from '../assets/images/phones/heroPhone.png';
// import betaNow from '../assets/images/phones/betanow.png';
// import earnMore from '../assets/images/phones/earnpoints.png';
// import circleLeft from '../assets/images/phones/circleLeft.png';
// import winPrizes from "../assets/images/phones/winprizes.png"
import apple from '../assets/images/applenew.png';
import google from '../assets/images/googledwnld.png'
import { Helmet } from 'react-helmet';
import uca from '../assets/images/uca/ultimateCannabis.png';


export const Home = () => {
	document.body.classList.remove('inner-page');

	return (
		<div>
			<Helmet>
				<title>CANNA42 | Home</title>
				<meta name="description" content="CANNA42 is a cannabis community platform that connects users with the best cannabis deals, products, dispensaries, and experiences near them." />
				<meta name="keywords" content="cannabis, community, platform, cannabis deals, products, dispensaries, experiences, CANNA42" />
				{/* canolical */}
				<link rel="canonical" href="https://canna42.com" />
			</Helmet>
			{/* Navbar Section*/}
			<NavbarComponent />

			{/* Home One Section Start */}
			<section className="slide-bg h-100" id="home">
				<div className="animation-circle">
					<i></i>
					<i></i>
					<i></i>
				</div>
				<div className="container" style={{
					paddingBottom: 50
				}}>
					<div className="row stinky-reverse">
						<div className="col-md-6" style={{
							marginBottom: -100,
						}}>
							<div className="d-flex-1">
								<div className="slide-text stinky-padding">
									<div>
										<h1 className="">COMMUNITY, CULTURE, EDUCATION, AND EXPERIENCES

										</h1>
										<h4 style={{ color: '#ffffff99', }
										}>
											Discover the best cannabis deals, products, dispensaries, and experiences near you with
											<span style={{ color: '#f8f7f3', fontFamily: 'carto-heavy' }}> CANNA<span style={{
												color: '#039447'
											}}>42</span></span>
											!
										</h4>
										<div style={{
											display: 'flex',
											flexDirection: 'row',
											gap: '20px'
										}}>
											<a href="https://apps.apple.com/us/app/canna42/id6478886245" target="_blank" rel="noreferrer" style={{ marginTop: '50px', display: 'inline-block' }}>
												<img src={apple} alt="apple" className="img-fluid" />
											</a>
											<a href="https://play.google.com/store/apps/details?id=com.canna42" target="_blank" rel="noreferrer" style={{ marginTop: '50px', display: 'inline-block' }}>
												<img src={google} alt="google" className="img-fluid" />
											</a>
										</div>
										{/* uca image */}
										<div onClick={() => {
											// navigate to /cannabis-adventure
											window.location.href = '/ultimate-cannabis-adventure';
										}} style={{
											display: 'flex',
											flexDirection: 'column',
											alignItems: 'center',
											gap: '20px',
											marginTop: '50px',
											justifyContent: 'center',
											width: '400px',
											cursor: 'pointer'
										}}>
											<img src={uca} alt="uca" style={{
												width: '250px',
											}} />
											<h3 className="m-0 p-0" style={{
												fontFamily: 'carto-heavy',
												color: '#fcb415'
											}}>JOIN THE FUN!</h3>
										</div>
										<div className="slid-btn">
											{/* <Link to={`${process.env.PUBLIC_URL}/request`}>
												<button className="btn-theme" style={{
													background: '#039447',
													// color: '#242424',
													color: 'white',
													fontFamily: 'carto-heavy'
												}}>BECOME A TESTER</button>
											</Link> */}

										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6">
							<div className="home-right">
								<div className="mobile-slid">
									<img src={heroPhone} alt="top1" className="img-fluid" />
								</div>
								{/* <div className="profile-msg">
									<img src={betaNow} alt="top2" className="img-fluid" />
								</div>
								<div className="awesome">
									<img src={earnMore} alt="top3" className="img-fluid" />
								</div>
								<div className="profile-1">
									<img src={circleLeft} alt="top4" className="img-fluid" />
								</div>
								<div className="emoji">
									<img src={winPrizes} alt="top5" className="img-fluid" />
								</div> */}

							</div>
						</div>
					</div>
				</div>


			</section>

			<Footer />

			{/*tap-top*/}
			<div className="tap-top">
				<div>
					<i className="fa fa-angle-up" aria-hidden="true"></i>
				</div>
			</div>
		</div >
	);
}

